/** Your data: the ERP topics and the spreadsheets the company added
 *  (backend/chainlit/data_upload_api.py). Socketless (App.tsx
 *  SOCKETLESS_ROUTES); open to every company user, the server refuses admins. */
import DataPage from '@/components/data/DataPage';
import { Header } from '@/components/header';
import { SidebarProvider } from '@/components/ui/sidebar';

export default function YourData() {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full flex-col">
        <Header />
        <div className="flex-1 overflow-auto" id="data-scroll">
          <DataPage />
        </div>
      </div>
    </SidebarProvider>
  );
}
